import { isClient } from './server.utils';

export const windowAdapter = isClient() ? window : ({} as any);
